import { render, staticRenderFns } from "./developing-style.vue?vue&type=template&id=b643e0ea&scoped=true"
import script from "./developing-style.vue?vue&type=script&lang=js"
export * from "./developing-style.vue?vue&type=script&lang=js"
import style0 from "./developing-style.vue?vue&type=style&index=0&id=b643e0ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b643e0ea",
  null
  
)

export default component.exports